import React, { Component } from "react";
import { withMapControl } from "../../shared/containers/containerMapControl";
import { withGeozones } from "../../shared/containers/geozonesContainer";
import styles from "./geozoneInfoControl.module.scss";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import GeozoneInfoProperty from "./GeozoneInfoProperty";
import { states } from "../../reducers/queriesStates";
import Preloader from "../../shared/items/static/preloader";
import TooltipWrapper from "../../shared/items/contols/tooltipWrapper";
import ModalConfirmWindow from "../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../Contents/ModalComponents/DeleteConfirm";

class GeozoneInfoControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectGeozone: props.selectGeozone,
      updateСompleted: false,
      deleteСompleted: false,
      requestError: false,
      isOpenDeleteConfirm: false,
    };
  }

  componentDidMount() {
    const { geozonesDataState, onGetGeozones } = this.props;

    if (geozonesDataState !== states.READY) {
      onGetGeozones();
    }
  }

  componentDidUpdate(prevProps) {
    const { selectGeozone, onSelectGeozone, geozoneUpdateDataState, geozoneDeleteDataState } = this.props;

    if ((prevProps.selectGeozone === null && selectGeozone !== null) || (prevProps.selectGeozone !== null && selectGeozone === null)) {
      this.setState({ selectGeozone });
    }

    if (prevProps.selectGeozone !== null && selectGeozone !== null) {
      if (prevProps.selectGeozone.id !== selectGeozone.id) {
        this.setState({ selectGeozone });
      }
    }

    if (geozoneUpdateDataState === states.READY && prevProps.geozoneUpdateDataState === states.REQUEST) {
      this.setState({ updateСompleted: true });

      const hideUpdateCompleted = () => {
        this.setState({ updateСompleted: false });
      };

      setTimeout(hideUpdateCompleted, 800);
    }

    if (geozoneDeleteDataState === states.READY && prevProps.geozoneDeleteDataState === states.REQUEST) {
      this.setState({ deleteСompleted: true });

      const hideDeleteCompleted = () => {
        onSelectGeozone(null);
        this.setState({ deleteСompleted: false });
      };

      setTimeout(hideDeleteCompleted, 800);
    }

    if (
      (geozoneUpdateDataState === states.FAILURE && prevProps.geozoneUpdateDataState === states.REQUEST) ||
      (geozoneDeleteDataState === states.FAILURE && prevProps.geozoneDeleteDataState === states.REQUEST)
    ) {
      this.setState({ requestError: true });

      const hideRequestError = () => {
        this.setState({ requestError: false });
      };

      setTimeout(hideRequestError, 5000);
    }
  }

  componentWillUnmount() {
    this.onClose();
  }

  handleEditTitle(e) {
    const { selectGeozone } = this.state;
    selectGeozone.title = e.target.value;

    this.setState({ selectGeozone });
  }

  onClose() {
    const { onSelectGeozone, onSetMapBounds } = this.props;
    onSetMapBounds(null);
    onSelectGeozone(null);
  }

  clickSaveButtonHandler() {
    const { onUpdateGeozone, onSetMapBounds } = this.props;
    const { selectGeozone } = this.state;

    this.setState({ updateСompleted: false, deleteСompleted: false, requestError: false });
    onSetMapBounds(null);
    onUpdateGeozone(selectGeozone.id, selectGeozone, false);
  }

  onDeleteGeozone() {
    this.setState({ isOpenDeleteConfirm: true });
  }

  onDeleteConfirm(e) {
    const { onDeleteGeozone, onSetMapBounds } = this.props;
    const { selectGeozone } = this.state;

    this.setState({ updateСompleted: false, deleteСompleted: false, requestError: false, isOpenDeleteConfirm: false });
    onSetMapBounds(null);
    onDeleteGeozone(selectGeozone.id);
  }

  onNotDeleteConfirm() {
    this.setState({ isOpenDeleteConfirm: false });
  }

  render() {
    const { selectGeozone, updateСompleted, deleteСompleted, requestError, isOpenDeleteConfirm } = this.state;
    if (selectGeozone === null) return null;

    const { geozoneRequestPocess } = this.props;

    return (
      <div key={selectGeozone.id} className={styles.overlayer_geozoneInfo_control_container}>
        <div className={styles.geozoneInfoContainer}>
          <TooltipWrapper title={"Закрыть панель геозонны"} position="right">
            <div className={styles.closeInfoControl} onClick={this.onClose.bind(this)}>
              <HighlightOffIcon fontSize="small" />
            </div>
          </TooltipWrapper>

          <div className={styles.titleContainer}>
            <div>Наименование геозоны</div>
            <input value={selectGeozone.title ?? ""} onChange={this.handleEditTitle.bind(this)} />
          </div>

          <div className={styles.propertiesContainer}>
            {selectGeozone.properties.map((item) => {
              return <GeozoneInfoProperty key={item.code} property={item} />;
            })}
          </div>

          <div className={styles.buttonsContainer}>
            <TooltipWrapper title={"Сохранить изменения"} position="bottom">
              <div onClick={this.clickSaveButtonHandler.bind(this)}>
                <button>Сохранить</button>
              </div>
            </TooltipWrapper>

            {updateСompleted ? <div className={styles.updateСompleted}>Изменения сохранены</div> : null}
            {deleteСompleted ? <div className={styles.deleteСompleted}>Геозона удалена</div> : null}
            {geozoneRequestPocess ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Preloader size={20} />
              </div>
            ) : null}
            {requestError ? <div className={styles.requestError}>Ошибка выполнения запроса</div> : null}

            <ModalConfirmWindow isOpen={isOpenDeleteConfirm}>
              <DeleteConfirm
                onConfirmHandle={this.onDeleteConfirm.bind(this)}
                onNotConfirmHandle={this.onNotDeleteConfirm.bind(this)}
                text={`Удалить геозону "${selectGeozone.title ?? ""}"?`}
              />
            </ModalConfirmWindow>

            <TooltipWrapper title={"Удалить геозону"} position="bottom">
              <div className={styles.buuttonDell} onClick={this.onDeleteGeozone.bind(this)}>
                <button>Удалить</button>
              </div>
            </TooltipWrapper>
          </div>
        </div>
      </div>
    );
  }
}

export default withMapControl(withGeozones(GeozoneInfoControl));
